import Results from './pages/Results.svelte';
import Authentication from './pages/Authentication.svelte';
import Answers from './pages/Answers.svelte';
import Admin from './pages/Admin.svelte';
import AddJob from './pages/admin-components/AddJob.svelte';
import AddQuestion from './pages/admin-components/AddQuestion.svelte';
import AddUser from './pages/admin-components/AddUser.svelte';
import AddMultipleUsers from './pages/admin-components/AddMultipleUsers.svelte';
import Home from './pages/Home.svelte';
import WaitForResults from './pages/WaitForResults.svelte';
import UserInfo from './pages/UserInfo.svelte';
import Feedback from './pages/Feedback.svelte';
import { wrap } from 'svelte-spa-router/wrap';
import { push } from 'svelte-spa-router';
import { isLoggedIn, isAdminUser, isGuidedUser, getQuestionnaireProgress } from './utility.js';
import CategoryList from "./pages/CategoryList.svelte";
import SubcategoryView from "./pages/SubcategoryView.svelte";

export let params;


async function checkAuthAndRedirect(destination) {
    let loggedIn = await isLoggedIn();
    if (!loggedIn) {
        // Redirect to auth page with the original destination as a query parameter
        push('/authentication?redirectTo=' + destination + '&m=protected');
        return false;
    }
    return true;
}

async function loadProtectedPage(detail) {
    const currentURL = window.location.hash;
    return await checkAuthAndRedirect(currentURL);
}

async function loadAdminPage() {
    return loadProtectedPage() && isAdminUser();
}

async function loadResultsPage(detail) {
    let isGuided = await isGuidedUser();
    if (!isGuided) {
        push('/wait-for-results');
        return false;
    }
    return true;
}

async function checkCategoryAccess(detail) {
    const isAdmin = await isAdminUser();
    if (isAdmin) {
        return true;
    }
    const data = await getQuestionnaireProgress();
    const progress = data.highest_available_category;

    if (!detail.params || !detail.params.page) {
        return true;
    }

    if (detail.params && progress >= detail.params.page) {
        return true;
    }
    console.log("tried to open unavailable category; sending to category list");
    push(`/questionnaire/`);
    return false;
}
  
const routes = {
    '/': Home,
    '/authentication': Authentication,
    '/user-info': wrap({
        component: UserInfo,
        conditions: [loadProtectedPage]
    }),
    '/questionnaire': wrap({
        component: CategoryList,
        conditions: [loadProtectedPage, checkCategoryAccess]
    }),
    '/questionnaire/:page/:sub': wrap({
        component: SubcategoryView,
        conditions: [loadProtectedPage, checkCategoryAccess]
    }),
    '/answers': wrap({
        component: Answers,
        conditions: [loadResultsPage]
    }),
    '/results': wrap({
        component: Results,
        conditions: [loadResultsPage]
    }),
    '/wait-for-results': wrap({
        component: WaitForResults,
        conditions: [loadProtectedPage]
    }),
    '/feedback': wrap({
        component: Feedback,
        conditions: [loadResultsPage]
    }),
    '/admin': wrap({
        component: Admin,
        conditions: [loadAdminPage]
    }),
    '/admin/add-job': wrap({
        component: AddJob,
        conditions: [loadAdminPage]
    }),
    '/admin/add-question': wrap({
        component: AddQuestion,
        conditions: [loadAdminPage]
    }),
    '/admin/add-user': wrap({
        component: AddUser,
        conditions: [loadAdminPage]
    }),
    '/admin/add-multiple-users': wrap({
        component: AddMultipleUsers,
        conditions: [loadAdminPage]
    }),
};

export default routes;
